/**
 * names.js — the ONE way item names are compared across Daily Ops (catalogs, de-dupe,
 * search, routes, closing ticks). Never compare raw names.
 */

/** Fold a name for dedup/matching: lowercase, collapse spaces, drop trailing punctuation. */
export function normalizeName(name) {
  return String(name == null ? '' : name)
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/[.,;:]+$/, '')
    .trim();
}
